if (!customElements.get('video-controls')) {
  class VideoControls extends HTMLElement {
    connectedCallback() {
      this.videos = Array.from(this.querySelectorAll('video'));
      this.handleClick = this.handleClick.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);
      this.videos.forEach((video) => video.addEventListener('click', this.handleClick));
      this.setAttribute('tabindex', '0');
      this.setAttribute('role', 'group');
      this.addEventListener('keydown', this.handleKeydown);
    }

    disconnectedCallback() {
      this.videos?.forEach((video) => video.removeEventListener('click', this.handleClick));
      this.removeEventListener('keydown', this.handleKeydown);
    }

    get video() {
      return this.videos?.find((video) => video.offsetParent !== null) ?? this.videos?.[0];
    }

    handleKeydown(e) {
      if (e.key === ' ' || e.key === 'Enter') {
        e.preventDefault();
        this.togglePlay();
      }
    }

    handleClick() {
      this.togglePlay();
    }

    togglePlay() {
      if (this.video.paused) {
        this.video.play();
      } else {
        this.video.pause();
      }
      const playing = !this.video.paused;
      this.classList.toggle('playing', playing);
      this.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
    }
  }
  customElements.define('video-controls', VideoControls);
}
